import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetPayoutRequestSchema,
  TGetPayoutResponseSchema,
} from "./getPayout.schema";

export const getPayout = (axios: IAxiosInstance) => {
  return async (params: TGetPayoutRequestSchema) => {
    const { odo_user_id, ...rest } = params;

    const response = await axios.noRetry.get<
      IApiResponse<TGetPayoutResponseSchema>
    >(`/api/charges-and-fees/${odo_user_id}/payouts`, { params: rest });

    return response.data;
  };
};
